// extracted by mini-css-extract-plugin
export default {"stickyHeader":"style_stickyHeader__rJO09"};